import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  PublishersList: lazyNamed(() => import('./pages/PublishersList'), 'PublishersList'),
  PublisherDetails: lazyNamed(() => import('./pages/PublisherDetails'), 'PublisherDetails'),
  AdConfigForm: lazyNamed(() => import('./pages/AdConfigForm'), 'AdConfigForm'),
  PublisherForm: lazyNamed(() => import('./pages/PublisherForm'), 'PublisherForm'),
};
